import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";
import moment from "moment";

const CountdownTimer = (props) => {
  const { className, endDate, autoAlert } = props;
  const currentTime = useRef(new Date());
  const [remainingTime, setRemaingTime] = useState(moment(endDate).diff(moment(currentTime.current)));
  const timer = useRef();

  useEffect(() => {
    if (remainingTime <= 0) {
      return timer.current && clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      setRemaingTime(remainingTime - 1000);
    }, 1000);

    return () => timer.current && clearTimeout(timer.current);
  }, [remainingTime]);

  const {
    _data: { days, hours, milliseconds, minutes, months, seconds, years },
  } = moment.duration(remainingTime);

  const countdownTimerClassName = classnames(
    "countdown-timer",
    {
      _urgent: remainingTime < autoAlert,
    },
    className,
  );

  return (
    <div className={countdownTimerClassName}>
      <span className="timer_days">{String(Math.max(days || 0, 0)).padStart(2, "0")}</span>
      <span className="timer_colon">:</span>
      <span className="timer_hours">{String(Math.max(hours || 0, 0)).padStart(2, "0")}</span>
      <span className="timer_colon">:</span>
      <span className="timer_minutes">{String(Math.max(minutes || 0, 0)).padStart(2, "0")}</span>
      <span className="timer_colon">:</span>
      <span className="timer_seconds">{String(Math.max(seconds || 0, 0)).padStart(2, "0")}</span>
    </div>
  );
};

export default CountdownTimer;
